import { Row } from 'antd'
import KCheckbox from 'app/components/Modules/Form/KCheckbox'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import SpinOverlay from 'app/components/UI-Elements/Feedback/Spin'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import React, { useState } from 'react'

import { PaymentContainerProps } from './typing'

const Paypal: React.FC<PaymentContainerProps> = ({ quote, portalId, route }) => {
  const { tRoute } = useTranslation({ scope: route.key })
  const [redirecting, setRedirecting] = useState(false)
  const onSuccess = (paypalPayment: IPaypalPayment) => {
    setRedirecting(true)
    window.location.href = paypalPayment.redirect_url
  }

  return (
    <Row gutter={[0, 24]}>
      <KCol span={24}>
        <Icon type="paypal" extension="png" />
      </KCol>
      <KCol span={24}>
        <p>{tRoute({ id: 'paypal_description' })}</p>
      </KCol>
      <KCol span={24}>
        <KForm
          onSuccess={onSuccess}
          initialValues={{ quote_id: quote?.id, rental_id: quote?.rental?.id }}
          recordType={RecordType.paypal_payment}
          initialFetch={false}
          portalId={portalId}>
          <KInputText name="quote_id" hidden />
          <KInputText name="rental_id" hidden />
          <KCheckbox name="agb" required hasFeedback={false} />
        </KForm>
      </KCol>
      <SpinOverlay loading={redirecting} />
    </Row>
  )
}

export default Paypal
